import { getAssetFilterList } from '@Actions/asset.actions';
import { clearRiskConfig } from '@Actions/Risk.actions';
import RiskList from '@Components/RiskList';
import { useIsFeatureEnabled } from '@innovyze/stylovyze';
import {
	selectRiskConfigsIsWaiting,
	selectRiskConfigsIsLoading,
	selectRiskConfigsPage,
} from '@innovyze/lib-am-common/Selectors';
import {
	getRiskConfigsClear,
	getAssetCounts,
} from '@innovyze/lib-am-common/Actions';
import { useGlobalization } from '@Translations/useGlobalization';
import { FullPage, FullPageWrapper } from '@Utils/styles';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getLoFConfigResolved } from '@Actions/LoF.actions';
import { getCoFComponentsResolved } from '@Actions/CoF.actions';
import { selectRiskConfigIsCreating } from '@Selectors/Risk.selectors';
import RiskCalcStatus from '@Components/RiskCalcStatus/RiskCalcStatus';
import { getAllAssetsSchemaAction } from '@innovyze/lib_asset_schema_store';
import { useLocation } from 'react-router-dom';
import { useSystemTypes } from '@Hooks/useSystemTypes';

export const RiskManagementList = () => {
	const dispatch = useDispatch();
	const { pathname } = useLocation();
	const { t } = useGlobalization();

	const isLoading = selectRiskConfigsIsLoading();
	const isWaiting = selectRiskConfigsIsWaiting();
	const isCreating = selectRiskConfigIsCreating();
	const riskPage = selectRiskConfigsPage();

	const isSaveFilterOn = useIsFeatureEnabled('info-360-assets-save-filter');

	const systemTypes = useSystemTypes();

	useEffect(() => {
		if (riskPage === undefined || riskPage.total === 0) {
			dispatch(getRiskConfigsClear());
			dispatch(getAssetCounts(systemTypes.map(s => s.id)));
		}
		dispatch(clearRiskConfig());
		dispatch(getLoFConfigResolved([]));
		dispatch(getCoFComponentsResolved([]));
		dispatch(getAllAssetsSchemaAction());
		// Cancel any polling
		RiskCalcStatus.cancelPollForCalcStatus();
	}, []);

	useEffect(() => {
		// Reload filters when nagivating back to /risk page
		if (String(pathname).includes('risk') && isSaveFilterOn) {
			dispatch(getAssetFilterList());
		}
	}, [pathname]);

	const riskListTab = () => {
		return (
			<FullPage>
				<RiskList />
			</FullPage>
		);
	};

	const secondaryNav = () => {
		const tabs = [{ content: riskListTab(), title: t('Risk Models') }];
		return tabs;
	};

	return (
		<FullPageWrapper
			className={isLoading || isWaiting || isCreating ? 'wait' : ''}
			title={t('Risk Models')}
			applyPadding={true}
			headerUnderline
			//secondary={<CreateSecondaryButtons />}
			secondaryNav={{
				items: secondaryNav(),
				itemIndex: 0,
			}}></FullPageWrapper>
	);
};
export default RiskManagementList;
